import { render, staticRenderFns } from "./lk-success-invite.vue?vue&type=template&id=06965f40&"
import script from "./lk-success-invite.vue?vue&type=script&lang=js&"
export * from "./lk-success-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/lk-success-invite.vue
// module id = 1368
// module chunks = 0